var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"institution-sign-in-button",class:{disabled: _vm.disabled},on:{"click":_vm.signIn}},[_c('school-outline-icon'),_c('div',{staticClass:"text"},[(_vm.loading)?_c('bounce-loading'):_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }